import React, { Component } from 'react';
import './_styles.scss';
import Utils, {setInitialFocus} from 'src/utils/Utils';
import {
  getTypeLanding, handleClickIniciaSesion,
  isLandingTelcelButtonEnabled
} from './utilsLandingTelmex';
import Carrusel from './components/carrusel/Carrusel';
import { getDynamicImage, getImageFromAsset, secondsToMiliseconds } from '../../../utils/Utils';
import SectionTelmex from './components/SectionTelmex/SectionTelmex';
import SectionOperation from './components/SectionOperation';
import { TYPE_LANDING_OPERATION } from './const';
import { LOGIN } from 'src/components/Modal/LoginQR/const';
import ButtonPrimary from './ButtonPrimary/index';
import { LocalTranslations, LocalAssets, LocalConfig } from 'src/requests/apa/local';
import translatesJson from './translates.json';
import assetsJson from './assets.json';
import configJson from './config.json';

const localTranslations = new LocalTranslations(translatesJson);
const localAssets = new LocalAssets(assetsJson);
const localConfig = new LocalConfig(configJson);

export default class LandingTelmex extends Component {
  constructor(props) {
    super(props);
    this.state = {
        cards: null,
        backgrounds: null,
        isTransitioning: false,
        isTelcelBtnVisible: isLandingTelcelButtonEnabled(),
      };
      const {carousel_config} = localConfig.get('landing_telmex_config', '{carousel_config: {enable:false}}');
      this.carousel_config = carousel_config || {enable:false};

    this.typeLanding = getTypeLanding();
  }

 async componentDidMount() {
    setInitialFocus('.landing-telmex__button-telmex');

    const images = (this.carousel_config.enable) ?  await getDynamicImage() : getImageFromAsset();

    // Verificar si images es un array de objetos o array plano
    const isObjectArray = Array.isArray(images) && images.length > 0 && typeof images[0] === 'object'

    const { cards, backgrounds } = isObjectArray
      ? this.separateImageFromApi(images)
      : this.separateImageFromAsset(images);
    this.setState({ cards, backgrounds });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.modalType && !nextProps.modalType && !this.carousel_config.enable) {
      const { cards, backgrounds } = this.separateImageFromAsset(getImageFromAsset());
      this.setState({ cards, backgrounds });
    }
  }

  // Separar las imágenes en cards y backgrounds cuando vienen de la API
  separateImageFromApi(images) {
    const cards = [];
    const backgrounds = [];
    images.forEach((item, index) => {
      cards.push({
        id: index,
        image: item.image_card_landscape
      });
      backgrounds.push({
        id: index,
        image: item.image_background_landscape
      });
    });
    return { backgrounds, cards };
  }

   // Función para rotar los fondos de pantalla
  rotateBackgrounds = () => {
    if(this.state.backgrounds.length <= 1) return;

    this.setState({ isTransitioning: true });
    setTimeout(() => {
      this.setState((prevState) => {
        const copy = [...prevState.backgrounds];
        copy.push(copy.shift());
        return { backgrounds: copy, isTransitioning: false };
      });
    }, 2000);
  }

  // Separar las imágenes en cards y backgrounds cuando vienen de apa/assets
  separateImageFromAsset(images) {
    const cards = images.slice(0, -1).map((image, index) => ({ id: index, image }));
    const backgrounds = [{ id: images.length - 1, image: images[images.length - 1] }];
    return { backgrounds, cards };
  }

  render() {
    const { cards, backgrounds, isTransitioning } = this.state;
    const { typeLanding } = this;

    return (
      <div className="landing-telmex" id="landingtelmex">

        <div className={`background-image ${isTransitioning ? 'animate-background invisible' : 'visible'}`} style={{ backgroundImage: `url(${backgrounds && backgrounds[0].image})` }} />
        {
          backgrounds && backgrounds[1] && (
            <div className={`background-image ${isTransitioning ? 'animate-background visible' : 'invisible'}`} style={{ backgroundImage: `url(${backgrounds && backgrounds[1].image})` }} />
          )
        }
        <div className="landing-telmex__header">
          <div className="landing-telmex__login-label">
            {Utils.cutPlayerString(
              localTranslations.get('Landing_Texto_Parrafo_YaTienesCuenta'),
              22
            )}
          </div>
          <ButtonPrimary
            title={Utils.cutPlayerString(
              localTranslations.get('Landing_Boton_Texto_IniciaSesion'),
              25
            )}
            type={LOGIN}
            onClick={() => handleClickIniciaSesion(this.props)}
          />
        </div>
        <div className="landing-telmex__row">

          <div className="landing-telmex__column landing-telmex__column--left">
            {typeLanding === TYPE_LANDING_OPERATION
              ? <SectionOperation
                  localAssets={localAssets}
                  localTranslations={localTranslations}
                />
              : <SectionTelmex 
                  localAssets={localAssets}
                  localTranslations={localTranslations}
               />
            }
          </div>

          <div className="landing-telmex__column landing-telmex__column--right">
             { cards &&
              <Carrusel
                images={cards}
                {...(this.carousel_config.enable  && backgrounds && backgrounds.length > 1 && {
                  animationConfig: {
                    interval: secondsToMiliseconds(this.carousel_config.seconds_to_transition),
                    onTransition: this.rotateBackgrounds
                  }
                })}
              />
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/index.jsx